/**
 * ForensicLogger
 * Provides high-fidelity logging for Mission Control.
 */
export const ForensicLogger = {
    log: (event: string, metadata: any) => {
        const forensicSubsystem = 'FORENSIC_SERVICE';
        const forensicEvent = event.toUpperCase().replace(/\s+/g, '_');

        import('../../../wingman-miami-spatial-04092026-main/src/spatial/utils/telemetry').then(({ telemetry }) => {
            telemetry.log({
                subsystem: forensicSubsystem,
                event: forensicEvent,
                level: 'FORENSIC',
                payload: metadata
            });
        }).catch(() => {
            // Fallback if telemetry not available
            console.info(`[FORENSIC][${forensicSubsystem}][${forensicEvent}]`, metadata);
        });

        // Integrate with OpenTelemetry if available
        if (typeof window !== 'undefined' && (window as any).WingmanTraceRecorder) {
            (window as any).WingmanTraceRecorder.recordDecision(
                `Forensic Event: ${event}`,
                null,
                metadata
            );
        }
    }
};

if (typeof window !== 'undefined') {
    (window as any).ForensicLogger = ForensicLogger;
}
